import CancelledReason from '@/models/Shared/CancelledReason';
import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CancelBookingRoleViewModel extends BaseUpdateRequest {
    bookingRoleId: string;
    cancelledReason: CancelledReason;
}